import Select, { components } from "react-select";

import * as statusIcons from "../../Icons/status";
import { Check, Dot, X, ChevronBottom } from "../../Icons/general-interface-1";
import { statusList, statusType } from "../../../utils/status/index";
import {
  control,
  clearIndicator,
  dropdownIndicator,
  indicatorSeparator,
  option,
  menu,
  menuList,
  placeholder,
  valueContainer,
} from "../commonStyles";
import commonStyles from "../index.module.scss";
import styles from "./index.module.scss";

type PropsType = {
  onChange: (status: { value: statusType; label: string }) => void;
  defaultValue?: { value: statusType; label: string };
  value?: { value: statusType; label: string };
};

function KeyedIcon(props) {
  const IconComponent = props.name ? statusIcons[props.name] : () => null;
  return <IconComponent className={props.style} />;
}

const ClearIndicator = ({ ...props }) => (
  <components.ClearIndicator {...props}>
    <X />
  </components.ClearIndicator>
);

const DropdownIndicator = ({ ...props }) => (
  <components.DropdownIndicator {...props}>
    <ChevronBottom />
  </components.DropdownIndicator>
);

const Option = (props) => (
  <components.Option {...props}>
    <KeyedIcon name={props.data.value} style={styles.optionsIcon} />
    <div className={styles.optionLabel}>{props.data.label}</div>
    {props.isSelected && <Check className={styles.iconCheck} />}
  </components.Option>
);

const Placeholder = (props) => {
  return (
    <components.Placeholder {...props}>
      <Dot className={styles.placeholderIcon} />
      {props.children}
    </components.Placeholder>
  );
};

const SingleValue = ({ ...props }) => (
  <components.SingleValue {...props}>
    <KeyedIcon name={props.data.value} style={styles.singleValueIcon} />
    {props.data.label}
  </components.SingleValue>
);

const customStyles = {
  control,
  clearIndicator,
  dropdownIndicator,
  indicatorSeparator,
  option,
  menu,
  menuList,
  placeholder,
  valueContainer,
  singleValue: (provided) => ({
    ...provided,
    color: commonStyles.grey_500,
    textTransform: "uppercase",
    fontFamily: commonStyles.font_bold,
    fontSize: "14px",
  }),
};

const StatusFilterDropdown = ({ onChange, defaultValue, value }: PropsType) => {
  const onDropdownSelect = (selection) => {
    onChange(selection);
  };

  return (
    <Select
      styles={customStyles}
      defaultValue={defaultValue}
      value={!value ? null : value}
      classNamePrefix="statusFilterDropdown"
      placeholder="Filter by status"
      onChange={onDropdownSelect}
      options={statusList}
      maxMenuHeight="197px"
      isSearchable={false}
      isClearable
      components={{
        ClearIndicator,
        DropdownIndicator,
        Option,
        Placeholder,
        SingleValue,
      }}
    />
  );
};

export default StatusFilterDropdown;
